import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { Card, ModalWrapper, ModalBodyWrapper, SmallContentContainer } from '@mews-commander/ui';
import { useCloseButton } from '../../../core/windowManager/hooks';
import ModalHeader from '../../../legacy/React/Components/Common/ModalHeader';
import { JobExecutorsForm } from './JobExecutorsForm';

export const JobsCreateDefault = () => {
    const closeButton = useCloseButton();

    const { data } = useRepositorySuspenseQuery('jobs', 'getJobsToCreate', {});

    return (
        <ModalWrapper>
            <ModalHeader title={<LocalizedText textKey={TextKey.JobPlural} />} primaryAction={closeButton} />
            <ModalBodyWrapper>
                <SmallContentContainer condensed>
                    <Card>
                        <JobExecutorsForm form="jobExecutors" jobExecutors={data.jobExecutors} />
                    </Card>
                </SmallContentContainer>
            </ModalBodyWrapper>
        </ModalWrapper>
    );
};
